import usePipelineStore from '../../../../stores/pipeline-store';
import { DrawerSelect } from './DrawerSelect';

type StepSelectProps = {
    value: string;
    onChange: (stepId: string) => void;
    /** Step id to exclude from the list (e.g. current step) */
    excludeStepId?: string;
    placeholder?: string;
};

export function StepSelect({
    value,
    onChange,
    excludeStepId,
    placeholder = 'Select Step',
}: StepSelectProps) {
    const pipeline = usePipelineStore((state) => state.pipeline);
    const steps = pipeline.steps || {};

    return (
        <DrawerSelect value={value} placeholder={placeholder} onChange={(e) => onChange(e.target.value)}>
            <option value="" disabled={true}>
                {placeholder}
            </option>
            {Object.keys(steps).map((id) => {
                if (id === excludeStepId || !steps[id]?.name) return null;
                return (
                    <option key={id} value={id}>
                        {steps[id].name}
                    </option>
                );
            })}
        </DrawerSelect>
    );
}
